// extracted by mini-css-extract-plugin
export default {"blog_hero":"blog_blog_hero__yejs5"};